import { createAsyncThunk } from "@reduxjs/toolkit";
import { companySliceName } from "..";
import server from "../../../../config/server";

export const insertCourseAction = createAsyncThunk(`${companySliceName}/insertCourse`, async (data) => {
  const response = await server.post("/app/course", data);
  return response.data;
});

export const updateCourseAction = createAsyncThunk(`${companySliceName}/updateCourse`, async (data) => {
  const response = await server.put("/app/course", data);
  return response.data;
});

export const getCoursesAction = createAsyncThunk(`${companySliceName}/getCourses`, async (_, thunkAPI) => {
  try {
    const response = await server.get("/app/course/views", {}, {});
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

export const deleteCourseAction = createAsyncThunk(`${companySliceName}/deleteCourse`, async (uuid, thunkAPI) => {
  try {
    const response = await server.delete(`/app/course?uuid=${uuid}`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
